import { PartCoverageFiltersDTO } from 'modules/inbound/programCoverage/infrastructure/dto/PartCoverageFiltersDTO';
import { FlowTypes } from '../infrastructure/dto/JitFlowTypesDTO';
import { IProvider, ISequencer } from './types';
import { CoverageStatus } from 'modules/inbound/shared/domain/CoverageStatusTypes';
import {
  CoverageStoppedAtFilter,
  QuantityStockFilter
} from '../ui/redux/PartCoverageFiltersReducer/types';

export interface PartCoverageFilters {
  family: string[];
  lines: number[];
  providersTier1Ids: IProvider[];
  logisticOperatorsIds: ISequencer[];
  models: string[];
  inbounders: string[];
  flowTypes: FlowTypes;
  status: CoverageStatus;
  prsOptions: string[];
  coverageStoppedAt: CoverageStoppedAtFilter;
  quantityStock: QuantityStockFilter;
}

class PartCoverageFiltersData {
  family: string[];
  lines: number[];
  providersTier1Ids: IProvider[];
  logisticOperatorsIds: ISequencer[];
  models: string[];
  inbounders: string[];
  flowTypes: FlowTypes;
  status: CoverageStatus;
  prsOptions: string[];
  coverageStoppedAt: CoverageStoppedAtFilter;
  quantityStock: QuantityStockFilter;

  constructor({
    family,
    lines,
    providersTier1Ids,
    logisticOperatorsIds,
    models,
    inbounders,
    flowTypes,
    status,
    prsOptions,
    coverageStoppedAt,
    quantityStock
  }: PartCoverageFilters) {
    this.family = family;
    this.lines = lines;
    this.providersTier1Ids = providersTier1Ids;
    this.logisticOperatorsIds = logisticOperatorsIds;
    this.models = models;
    this.inbounders = inbounders;
    this.flowTypes = flowTypes;
    this.status = status;
    this.prsOptions = prsOptions || [];
    this.coverageStoppedAt = coverageStoppedAt;
    this.quantityStock = quantityStock;
  }

  static generateFromDTO({
    family,
    lines,
    tier_1_provider_ids,
    logistic_operators_ids,
    models,
    inbounders,
    flow_types,
    sequencer_coverage_status,
    prs,
    coverage_stopped_at,
    quantity_stock
  }: PartCoverageFiltersDTO): PartCoverageFilters {
    return new PartCoverageFiltersData({
      family,
      lines,
      providersTier1Ids: tier_1_provider_ids,
      logisticOperatorsIds: logistic_operators_ids,
      models,
      inbounders,
      flowTypes: flow_types,
      status: sequencer_coverage_status,
      prsOptions: prs,
      coverageStoppedAt: coverage_stopped_at,
      quantityStock: quantity_stock
    });
  }
}

export default PartCoverageFiltersData;
